import axios from 'axios';
import Cookies from 'js-cookie';

import { FASTAPI_HOST } from './config';
import { getLocalBuddyAvatar } from './buddyAvatarStore';
import { apiBuddyToProfile } from './buddyProfiles';

let cachedProfiles = null;
let cachedToken = '';
let pendingLoad = null;

const currentToken = () => Cookies.get('user_token') || '';

export async function getBuddyProfiles({ force = false, fetcher } = {}) {
  const token = currentToken();
  if (token !== cachedToken) {
    cachedProfiles = null;
    pendingLoad = null;
    cachedToken = token;
  }
  if (!force && cachedProfiles) return cachedProfiles;
  if (pendingLoad) return pendingLoad;

  pendingLoad = (async () => {
    const response = fetcher
      ? await fetcher()
      : await axios.get(`${FASTAPI_HOST}/api/user-buddies`, {
        headers: { Authorization: `Bearer ${token}` },
      });
    const profiles = await Promise.all((response.data?.buddies || []).map(async (item) => {
      const profile = apiBuddyToProfile(item);
      const localAvatar = profile.image
        ? ''
        : await getLocalBuddyAvatar(profile.id).catch(() => '');
      return { ...profile, image: profile.image || localAvatar };
    }));
    cachedProfiles = profiles;
    return profiles;
  })();

  try {
    return await pendingLoad;
  } finally {
    pendingLoad = null;
  }
}

export function setCachedBuddyProfiles(profiles) {
  cachedToken = currentToken();
  cachedProfiles = Array.isArray(profiles) ? profiles : null;
}

export function invalidateBuddyProfiles() {
  cachedProfiles = null;
  pendingLoad = null;
}

export async function refreshBuddyProfile(buddyId) {
  const profiles = await getBuddyProfiles({ force: true });
  return profiles.find((profile) => profile.id === buddyId) || null;
}
